import { get, map, find, isEmpty, filter, reduce, keyBy } from 'lodash';
import { createOfferQuote, hostUpdateQuote } from '../../../actions/contracts';
import { updatePayload } from '../../../actions/payload';
import update from 'immutability-helper';

const onChangeAddItemsForm = (values, dispatch, props) => {
  const { bookingId, isHostUpdate } = props;
  const payload = get(props, 'payload.data');
  const accessToken = get(props, 'auth.accessToken');
  const items = get(values, 'addOns');

  const itemsById = keyBy(filter(items, (item) => !!item), '_id'); // filter out undefined items and keyby id
  const removedAddons = isHostUpdate ? reduce(get(payload, 'items', []), (result, value) => {
    const itemId = get(value, 'info.item_id', '');
    if (itemId && !itemsById[itemId]) {
      // isolate the removed item
      const updatedValue = update(value, {
        info: { delete: { $set: true } }
      });
      result.push(updatedValue);
    }
    return result;
  }, []) : [];
  const addOns = map(items, item => {
    if ((item || !isEmpty(item)) && item._id) {
      return {
        type: 'ITEM',
        info: {
          item_id: item._id || item.item_id,
          custom_price: Number(item.unit_cost) || 0,
          count: Number(item.count) || 0
        }
      };
    }
  });

  const filteredAddOns = filter(addOns, { type: 'ITEM' });
  const bookingData = find(payload.items, { type: 'BOOKING' });
  const addOnsPayload = {
    ...payload,
    items: [
      bookingData,
      ...filteredAddOns,
      ...removedAddons
    ]
  };

  if (addOns) {
    if (isHostUpdate) {
      return dispatch(hostUpdateQuote(addOnsPayload, bookingId, accessToken, response => {
        if (200 === response.statusCode) {
          return dispatch(updatePayload(addOnsPayload));
        }
      }));
    }
    dispatch(createOfferQuote(addOnsPayload, accessToken, response => {
      if (200 === response.statusCode) {
        return dispatch(updatePayload(addOnsPayload));
      }
    }));
  }
};

export default onChangeAddItemsForm;
